import React, { useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import GridContainer from '../global/GridContainer/GridContainer';
import CommunityDetailsItem from './componests/CommunityDetailsItem';

const CommunityDetails = ({
  currentCommunity,
  getCommunityByid,
  resetCommunityByid,
  updateCommunity,
  addAlertToAlerts,
  currentUser,
}) => {
  const params = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { id } = params;
  const mapView = searchParams.get('mapview') || false;

  useEffect(() => {
    getCommunityByid(id);

    return () => {
      resetCommunityByid();
    };
  }, []);

  return (
    <div className="community-container">
      <GridContainer>
        <div className="community-container--upper">
          <div
            className="community-container-header-back-link"
            onClick={() => navigate(`/communities/?mapview=${mapView}`)}
          >
            <FontAwesomeIcon
              icon={['fas', 'chevron-left']}
              className="feed-group-header-back-link-icon"
            />
            {'Go back'}
          </div>
          <h3 className="title m-0">Community Hub</h3>
        </div>
        {currentCommunity ? (
          <CommunityDetailsItem
            community={currentCommunity}
            updateCommunity={updateCommunity}
            addAlertToAlerts={addAlertToAlerts}
            currentUser={currentUser}
          />
        ) : (
          <div className="d-flex pt-4">
            <p className="community-container-text">
              We are unable to find the community. Please try again later.
            </p>
          </div>
        )}
      </GridContainer>
    </div>
  );
};

export default CommunityDetails;
